import {IconComponent, useApp} from '@backstage/core-plugin-api';
import {TemplateEntityV1beta3} from '@backstage/plugin-scaffolder-common';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import {makeStyles, Theme} from '@material-ui/core/styles';
import LanguageIcon from '@material-ui/icons/Language';
import {Link} from '@backstage/core-components';

export interface AppCardLinkProps {
    icon: IconComponent;
    text: string;
    url: string;
}

const useStylesCardLink = makeStyles(() => ({
    linkText: {
        display: 'inline-flex',
        alignItems: 'center',
    },
}));

const AppCardLink = ({icon: Icon, text, url}: AppCardLinkProps) => {
    const styles = useStylesCardLink();

    return (
        <div className={styles.linkText}>
            <Icon fontSize="small"/>
            <Link style={{marginLeft: '8px'}} to={url}>
                {text || url}
            </Link>
        </div>
    );
};


const useStyles = makeStyles<Theme>({});

export interface AppTemplateCardLinksProps {
    template: TemplateEntityV1beta3;
    additionalLinks?: {
        icon: IconComponent;
        text: string;
        url: string;
    }[];
}

const AppTemplateCardLinks = ({
                                  template,
                                  additionalLinks,
                              }: AppTemplateCardLinksProps) => {
    const styles = useStyles();
    const app = useApp();
    const iconResolver = (key?: string): IconComponent =>
        key ? app.getSystemIcon(key) ?? LanguageIcon : LanguageIcon;

    return (
        <>
            <Grid item xs={12}>
                <Divider data-testid="template-card-separator--links"/>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={2} data-testid="template-card-links">
                    {additionalLinks?.map(({icon, text, url}, index) => (
                        <Grid
                            className={styles.linkText}
                            item
                            xs={6}
                            key={index}
                            data-testid="template-card-links--item"
                        >
                            <AppCardLink icon={icon} text={text} url={url}/>
                        </Grid>
                    ))}
                    {template.metadata.links?.map(({url, icon, title}, index) => (
                        <Grid
                            className={styles.linkText}
                            item
                            xs={6}
                            key={index}
                            data-testid="template-card-links--metalink"
                        >
                            <AppCardLink
                                icon={iconResolver(icon)}
                                text={title || url}
                                url={url}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </>
    );
};

export default AppTemplateCardLinks;
